import { useState, useRef } from "react";
import { Button, TextField, Stack, DialogProps } from "@mui/material";
import { tss } from "tss-react";
import ApiUtils from "api/Utils";
import ModalWindow from "components/ModalWindow";
import {CommonDialogBox} from "components";
import EventsEmitter from "events/EventsEmitter";

const useStyles = tss.create(() => ({
    title: {
        fontSize: 16,
        fontWeight: "bold",
    },
    header: {
        fontSize: 12,
        color: "rgba(0,0,0,0.55)",
    },
    margin: {
        marginTop: -5,
    },
    button: {
        minWidth: 20,
        padding: "5px 5px",
        marginLeft: 5,
        width: 75,
        height: 36,
    },
    bottom: {
        position: "absolute",
        top: "calc(100% - 49px)",
        right: 22,
    },
    nextButton: {
        fontWeight: "bold",
    },
    cancelButton: {
        right: 14,
        fontWeight: "bold",
    },
}));

type IProps = {
    open: boolean;
    catalog: any;
    handleClose: (cancelled: boolean) => void;
};

export default function NewFolderPanel(props: IProps) {
    const { classes, cx } = useStyles();
    const [folderName, setFolderName] = useState("");
    const { catalog, open } = props;
    const catalogId = catalog?.ID;
    const inputRef = useRef<HTMLDivElement | null>(null);
    const fileFolderId = catalog?.entity?.project === catalogId ? "0" : catalogId;
    const projectId = catalog?.project;
 
    const closeComposeDialog: DialogProps["onClose"] = (event, reason) => {
        setFolderName("");
        props.handleClose(false);
    }

    const onFocus = () => {
        inputRef?.current?.focus();
    };

    const handleOk = () => {
        ApiUtils.remoteCreateFolder(projectId, fileFolderId, folderName, {}, () => {
            setFolderName("");
            props.handleClose(true);
            EventsEmitter.emit("reloadData", "");
        });
    };

    const handleChange = (event: any) => {
        setFolderName(event.target.value);
    };

    const handleKeyPress = (event: any) => {
        if (event.key === "Enter") {
            handleOk();
        }
    };

    const DialogAction = () => {
        return (
            <div style={{paddingRight: '15px'}}>
                <Button
                    onClick={(e) => {
                        closeComposeDialog(e, 'escapeKeyDown');
                    }}
                    className={[classes.button, classes.cancelButton].join(" ")}
                >
                    Cancel
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={(e) => {
                        handleOk();
                    }}
                    className={[classes.button, classes.nextButton].join(" ")}
                >
                    Create
                </Button>
            </div>
        )
    }

    return (
        <CommonDialogBox
            classes={{
                paper: 'm-24 rounded-8 white-bg'
            }}
            open={open}
            handleClose={closeComposeDialog}
            fullWidth
            maxWidth="sm"
            subtitle1='Add folder'
            titleh5=''
            dialogAction={<DialogAction />}
            displayScrollBar={true}
            maxHeight={600}
        >
            <TextField
                id="folder-name"
                label="Folder Name"
                //className={classes.textField}
                onChange={handleChange}
                value={folderName}
                fullWidth
                inputRef={inputRef}
                onKeyDown={handleKeyPress}
                inputProps={{ "aria-label": "Name" }}
            />
        </CommonDialogBox>
    );
}
